<template>
    <div>
        <answer-header type="back" v-if="referer == 'Menu'"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="rule-content">
            <h2>{{title}}</h2>
            <div v-html="content"></div>
        </div>
        <div v-if="referer != 'Menu'" class="btn btn-blue btn-block" @click="_startAn">အတည္ျပဳသည္</div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Rule',
    components: {answerHeader},
    data(){
        return {
            referer: '',
            title: '',
            content: ''
        }
    },
    beforeRouteEnter (to, from, next){
        next(vm => {
            vm.referer = from.name
        })
   },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        Utils.$ajax({
            url: '/share/rules',
        }).done(res =>{
            if (res.code != 0){
                this.$toast(res.msg);
                return;
            }
            this.title = res.data.title;
            this.content = res.data.content;
        })
    },
    methods: {
        _startAn(){
            this.$router.push(`/answer`);
        },
    }
}
</script>

<style lang="scss" scoped>
    .rule-content{
        color: #000;
        height: rem(700);
        overflow-y: scroll;
        margin-bottom: rem(30);
        h2{
            font-size: rem(36);
            font-weight: bold;
        }
        p{
            margin: .5em 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Rule.vue